var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"fill-button",class:_vm.customClasses},[_c('span',{staticClass:"content"},[_vm._t("default")],2),(_vm.hasIcon)?_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.indicat)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }